import Vue from 'vue';

// Components
import FieldComponents from './components/FieldComponents';
import HelperComponents from './components/HelperComponents';

// Directives
import Directives from './directives';

// Filters
import Filters from './filters';

// Methods
import Methods from './methods';

const components = {
	...HelperComponents,
	...FieldComponents
};

const directives = { ...Directives };
const filters = { ...Filters };
const methods = { ...Methods };

const registerToVue = (object, type, config = null) => {
	Object.keys(object).forEach(name => {
		if (config) {
			Vue[type](name, object[name](config));
		} else {
			Vue[type](name, object[name]);
		}
	})
};

const registerMethods = (methods, config) => {
	const methodsMixin = Object.keys(methods).reduce((acc, method) => {
		acc[method] = methods[method](config);
		return acc;
	}, {});
	Vue.mixin({ methods: methodsMixin });
};

export default {
	register (options) {
		const config = options && options.config || {};
		if (options && methods.isArray()(options.components)) {
			options.components.forEach(name => {
				Vue.component(name, components[name]);
			});
		} else {
			if (!options || options.components !== false) registerToVue(components, 'component');
		}
		registerToVue(directives, 'directive', config);
		registerToVue(filters, 'filter', config);
		registerMethods(methods, config);
	}
};
